import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ShieldAlert, ArrowLeftCircle } from 'lucide-react';

import { setSuperAdmin } from '@/store/actions/creators/authActions';

const ADMIN_BACKUP_KEY = 'authTokenAs';
const ADMIN_USER_BACKUP_KEY = 'authUserDataAs';

function readImpersonatedAdmin(): { login?: string; firstName?: string; lastName?: string } | null {
  const raw = sessionStorage.getItem(ADMIN_USER_BACKUP_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function ImpersonateBanner() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [admin, setAdmin] = useState(() =>
    sessionStorage.getItem(ADMIN_BACKUP_KEY) ? readImpersonatedAdmin() : null,
  );

  useEffect(() => {
    const onStorage = () => {
      setAdmin(
        sessionStorage.getItem(ADMIN_BACKUP_KEY) ? readImpersonatedAdmin() : null,
      );
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (!admin) return null;

  const adminName =
    [admin.firstName, admin.lastName].filter(Boolean).join(' ') ||
    admin.login ||
    'admin';

  const handleReturn = () => {
    // @ts-expect-error legacy redux-thunk
    dispatch(setSuperAdmin());
  };

  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-100 md:px-6">
      <div className="flex items-center gap-2 min-w-0">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span className="truncate">
          {t('IMPERSONATE.ACTIVE_BANNER') ??
            "Mode impersonation actif — vous naviguez en tant qu'utilisateur."}
        </span>
      </div>
      <button
        type="button"
        onClick={handleReturn}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-amber-900 px-3 py-1 text-xs font-medium text-amber-50 transition hover:bg-amber-800 dark:bg-amber-100 dark:text-amber-900 dark:hover:bg-amber-50"
      >
        <ArrowLeftCircle className="h-3.5 w-3.5" />
        {t('IMPERSONATE.RETURN_TO_ADMIN') ?? 'Retour au mode admin'}
        <span className="hidden sm:inline">· {adminName}</span>
      </button>
    </div>
  );
}
